import { useEffect, useState } from "react";
import { DBApplication } from "../../interfaces/CoObject";
import { Dimension } from "../../../api/models/dimension";
import { fetchGroupUserDB } from "../../../api/object/Form";
import { DimensionParameter } from "../../../api/models/dimension-parameter";
import { DimensionDetail } from "../../../api/models/dimension-detail";

export interface DocumentParametersProps {
  parameters: DimensionParameter[];
  updateParameters: (doc: DimensionParameter[], valid: boolean, modified: boolean) => void;
  canInherit: boolean;
  inheritableParameters: DimensionParameter[] | undefined;
  readonly?: boolean;
}

interface DocumentParameterState {
  availableDbApplication: DBApplication[] | undefined;
  isContextualMenuOpen: boolean;
}

const useDocumentParameters = (props: DocumentParametersProps) => {
  const [state, setState] = useState<DocumentParameterState>({
    availableDbApplication: undefined,
    isContextualMenuOpen: false,
  });

  const { parameters, updateParameters, inheritableParameters, readonly } = props;

  useEffect(() => {
    const getInitialValues = async () => {
      const dbs = await fetchGroupUserDB();
      setState((s) => ({
        ...s,
        availableDbApplication: dbs,
      }));
      updateParameters(parameters, true, false);
    };

    void getInitialValues();
  }, []);

  const updateDimensionFromTree = (
    dimensionItem: Dimension,
    newDimensions: DimensionDetail[] | undefined,
    dimensionParameter: DimensionParameter
  ) => {
    if (readonly) return;
    const dimensionToAdd: DimensionDetail[] = newDimensions?.map((newDimension) => ({
      ...newDimension,
      dimensionOid: dimensionItem.oid,
      structureCode: dimensionItem.type,
      code: dimensionItem.code,
    })) || [];

    const newDimensionParameter = parameters.map((p) => {
      if (p.dbId !== dimensionParameter.dbId) return p;
      const updatedDimensions = p.dimensions.filter((d) => d.dimensionOid !== dimensionItem.oid);
      updatedDimensions.push(...dimensionToAdd);
      return { ...p, dimensions: updatedDimensions };
    });

    setState((s) => ({ ...s, dimensionParameters: newDimensionParameter }));
    updateParameters(newDimensionParameter, true, true);
  };

  return {
    state,
    parameters,
    updateParameters,
    inheritableParameters,
    updateDimensionFromTree,
    readonly,
  };
};

export default useDocumentParameters;
